import {NgModule} from "@angular/core";
import {AddUserComponent} from "./add-user.component";
import {CommonModule} from "@angular/common";
import {MatCardModule} from "@angular/material/card";
import {MatDialogModule} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {MatButtonModule} from "@angular/material/button";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatRadioModule} from "@angular/material/radio";
import {AdminFormHelperService} from "@app/pages/admin/admin-form-helper.service";
import {MatIconModule} from "@angular/material/icon";


@NgModule({
    declarations: [AddUserComponent],
    imports: [
        CommonModule,
        MatCardModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        FormsModule,
        MatRadioModule,
        ReactiveFormsModule,
        MatIconModule
    ],
    exports: [AddUserComponent],
    providers: [AdminFormHelperService]
})
export class AddUserModule { }
